import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DocumentManagementSystemComponent} from './document-management-system.component';

const routes: Routes = [
    {
        path: 'document-management-system', component: DocumentManagementSystemComponent
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/document-management-system/document-management-system.routing.ts